<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lBlz4j/tc-custom/9780063075771.jpg?1731055907283" alt="This image is the cover for the book Thurber Carnival"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thurber Carnival
      </h1>
      <p class="bookDescription body article font2">
        <b>“An authentic American genius . . . Mr. Thurber belongs in the great lines of American humorists that includes Mark Twain and Ring Lardner.” —<i>The Philadelphia Inquirer</i></b><br/><br/>James Thurber’s unique ability to convey the vagaries of life in a funny, witty, and often satirical way earned him accolades as one of the finest humorists of the twentieth century. A bestseller upon its initial publication in 1945, <i>The Thurber Carnival</i> captures the depth of his talent and the breadth of his wit. The stories compiled here, almost all of which first appeared in <i>The New Yorker</i>, are from his uproarious and candid collection <i>My World and Welcome to It</i>—including the American classic “The Secret Life of Walter Mitty’—as well as from <i>The Owl in the Attic</i>, <i>The Seal in the Bathroom</i>, and <i>Men, Women and Dogs</i>. Thurber’s take on life, society, and human nature is timeless and will continue to delight readers even as they recognize a bit of themselves in his brilliant sketches.<br/><br/><b>“One of the absolutely essential books of our time.” —<i>Saturday Review of Literature</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Thurber
      </h2>
      
      <p class="authorDescription body article"><P>James Thurber was born in Columbus, Ohio, in 1894. Famous for his humorous writings and illustrations, he was a staff member of <I>The New Yorker</I> for more than thirty years. He died in 1961. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44f70c25